import { createSlice } from '@reduxjs/toolkit';

// Центр уведомлений внутри CRM: события, пришедшие по сокету, пока открыта любая страница.
// Хранится только в памяти вкладки (после перезагрузки счётчики «Входящих» подтягиваются с сервера, лента начинается заново).
// item: { id, type: 'message' | 'lead' | 'call', text, to, at, seen }
const MAX = 30;

const slice = createSlice({
  name: 'notifications',
  initialState: { items: [] },
  reducers: {
    pushNotification: (state, { payload }) => {
      state.items.unshift({ seen: false, at: Date.now(), ...payload });
      if (state.items.length > MAX) state.items.length = MAX;
    },
    markAllSeen: (state) => { state.items.forEach((i) => { i.seen = true; }); },
    markSeen: (state, { payload }) => { const i = state.items.find((x) => x.id === payload); if (i) i.seen = true; },
    clearNotifications: (state) => { state.items = []; },
  },
});

export const { pushNotification, markAllSeen, markSeen, clearNotifications } = slice.actions;
export default slice.reducer;
